import * as Constants from './constants'

export const permissionRoleListRequest = function permissionRoleListRequest(formData) {
  return {
    type: Constants.PERMISSION_ROLE_LIST_REQUESTING,
    payload: formData
  }
}

export const permissionRoleListSuccess = function permissionRoleListSuccess(data) {
  return {
    type: Constants.PERMISSION_ROLE_LIST_SUCCESS,
    data
  }
}

export const permissionRoleListError = function permissionRoleListError(error) {
  return {
    type: Constants.PERMISSION_ROLE_LIST_ERROR,
    error
  }
}

export const permissionRoleDetailRequest = function permissionRoleDetailRequest(formData) {
  return {
    type: Constants.PERMISSION_ROLE_DETAIL_REQUESTING,
    payload: formData
  }
}

export const permissionRoleDetailSuccess = function permissionRoleDetailSuccess(data) {
  return {
    type: Constants.PERMISSION_ROLE_DETAIL_SUCCESS,
    data
  }
}

export const permissionRoleDetailError = function permissionRoleDetailError(error) {
  return {
    type: Constants.PERMISSION_ROLE_DETAIL_ERROR,
    error
  }
}

export const permissionRoleUpdateRequest = (formData, callback) => {
  return {
    type: Constants.PERMISSION_ROLE_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const permissionRoleUpdateSuccess = function permissionRoleUpdateSuccess(response) {
  return {
    type: Constants.PERMISSION_ROLE_UPDATE_SUCCESS,
    payload: response
  }
}

export const permissionRoleUpdateError = function permissionRoleUpdateError(error) {
  return {
    type: Constants.PERMISSION_ROLE_UPDATE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/PermissionRole/actions.js